import { render, staticRenderFns } from "./PublicPositiveInformation.vue?vue&type=template&id=de2cf6f8&scoped=true"
import script from "./PublicPositiveInformation.vue?vue&type=script&lang=js"
export * from "./PublicPositiveInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2cf6f8",
  null
  
)

export default component.exports